define('SuiteDynamics.PickedForYouHomepage.Slider',
	[
		'SuiteDynamics.PickedForYouHomepage.Slider.View'
	],
	function (
		SliderView
	)
{
	'use strict';
	
	return  {
		mountToApp: function mountToApp (container) {
			var layout = container.getComponent('Layout');
			var environment = container.getComponent('Environment');

			if (layout && environment) {
				var itemIds = environment.getConfig('pickedForYou.items') || [];
				if (itemIds.length) {
					layout.addChildView('PickedForYou.Homepage', function () {
						return new SliderView({ container: container });
					});
				}
			}
		}
	};
});
